import { render, staticRenderFns } from "./rmsRoomTypesReport.vue?vue&type=template&id=54fafa55&scoped=true"
import script from "./rmsRoomTypesReport.vue?vue&type=script&lang=js"
export * from "./rmsRoomTypesReport.vue?vue&type=script&lang=js"
import style0 from "./rmsRoomTypesReport.vue?vue&type=style&index=0&id=54fafa55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fafa55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
